import React, {useEffect, useState, useRef} from 'react'
import {useDispatch, useSelector} from "react-redux";
import { fetchDatumById } from "../../../../../../store/user_organizations/teams/tools/connect_and_align/thunks";
import {Loading} from "../../../../../ui/loading/Loading";
import Nav from "react-bootstrap/Nav";
import {HeadlineModal} from "../../../../../ui/tools/HeadlineModal";
import {ReminderModal} from "../../../../../ui/tools/ReminderModal";
import './MemberPanel.scss'
import Accordion from "react-bootstrap/Accordion";
import {DatumAccordionItem} from "../../../components/DatumAccordionItem";
import {zynity_api} from "../../../../../../config/external-routes";
import Swal from "sweetalert2";
import axios from "axios";
import ModalDialog from 'react-bootstrap/ModalDialog';
import Draggable from 'react-draggable';
import {getCoachNotes, setCoachNoteOpen} from "../../../../../../store/coaches/teams/coach_notes";
import {
    collabSetRemember,
    getCnAData, ICollabRemember,
    setDatumIdOpen,
    setDatumIdOpenData, updateCnAData
} from "../../../../../../store/user_organizations/teams/tools/connect_and_align";
import {
    findDatumByDatumId,
    findDatumByDatumIdInAllTools,
    getAuthorIdByEmail,
    getAuthorInitials
} from "../../../../../../helpers/tools";
import {isDatumDraft} from "../../../../../../helpers/cnaDraft";
import {changePriority} from "../../../../../../helpers/changeListOrder";
import {setRoute} from "../../../../../../store/routes";
import {useNavigate, useParams} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {Button, Form, Modal} from "react-bootstrap";

class DraggableModalDialog extends React.Component {
    render() {
        return <Draggable handle=".draggableHandler"><ModalDialog {...this.props} />
        </Draggable>
    }
}

export const MemberPanel = ({selectedMember}: any) => {
    const navigateTo = useNavigate()
    const dispatch = useDispatch();
    const {datum_id} = useParams(); // Get datum_id from URL
    const datumOpenId = useSelector((state: any) => state.tool_cna.datum_id_open);
    const app_router = useSelector((state: any) => state.router)
    const cna = useSelector((state: any) => state.tool_cna)
    let cna_data = Array.isArray(cna.data) ? cna.data : [];
    let cna_archived_data = Array.isArray(cna.archived_data) ? cna.archived_data : [];
    let isLoadingArchivedData = cna.isLoadingArchivedData;
    const authenticated_user = useSelector((state: any) => state.auth);
    const team_obj = useSelector((state: any) => state.organization_team);
    const tool_cna_remember = useSelector((state: any) => state.tool_cna_remember);
    const [showReminderModal, setShowReminderModal] = useState(false);
    const [showMoveItemModal, setShowMoveItemModal] = useState(false);
    const [moveItemSelectedItemId, setMoveItemSelectedItemId] = useState(0);
    const [moveItemNewType, setMoveItemNewType] = useState('');
    const [isNewReminder, setIsNewReminder] = useState(true);
    const [reminder, setReminder] = useState('');
    const [showCreateItemModal, setShowCreateItemModal] = useState(false);
    const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);
    let team_services = team_obj.data.services[0];
    const [headlineModalSettings, setHeadlineModalSettings] = useState({
        title: 'New TOMI',
        is_comment: false,
        new_record: true,
        is_draft: false,
        enable_document_library: true,
        labels: {
            title: 'TOMI',
            description: 'Story'
        }
    });

    const [headlineData, setHeadlineData] = useState({
        content_id: '',
        title: '',
        description: '',
        links: [],
        uploads: [],
        document_library_item_ids: [],
        document_library_items: [],
        type: '',
        start_date: '',
        start_time: '',
        end_date: '',
        end_time: '',
        is_all_day: false,
        event_location: '',
        add_to_calendar: false,
        event_attendees: [],
        custom_attendees: ''
    });
    
    const [eventData, setEventData] = useState({
        start_date: '',
        start_time: '',
        end_date: '',
        end_time: '',
        is_all_day: false,
        event_location: '',
        add_to_calendar: false,
        event_attendees: [],
        custom_attendees: ''
    });

    let 
    
    datum_types = [
        {
            name: 'Deliverables',
            singular: 'Deliverable'
        }
    ];

    if(team_services.SKU == 'Z01B' || team_services.SKU == 'Z01C') {
        datum_types.push({
                name: 'TOMIs',
                singular: 'TOMI'
            },
            {
                name: 'Activities',
                singular: 'Activity'
            })
    }

    datum_types.push({
        name: 'Messages',
        singular: 'Message'
    })

    const parseToolsNamesToTabNames = (tool:string) => {
        if(tool == 'deliverables') {
            return 'Deliverables'
        } else if(tool == 'tomis') {
            return 'TOMIs'
        } else if(tool == 'activities') {
            return 'Activities'
        } else if(tool == 'messages') {
            return 'Messages'
        }
    }

    const getDatumModalOpenKey = () => {

        let datumOpenId = cna.datum_id_open.toString();

        if(datumOpenId == '0') {
            if(cna.isLoading === false && cna.isLoadingFullData === false) {
                let remember_data = tool_cna_remember?.remember
                if(remember_data != null && remember_data.length > 0) {
                    const organization_id = team_obj.data.idOrganization;
                    const team_id = team_obj.data.id;

                    let organizationData = remember_data.find((org: { organization_id: number; team_id:number; view:'team'|'member'}) => (
                        org.organization_id === organization_id && org.team_id === team_id && org.view === 'member'
                    ));

                    if(organizationData) {
                        let user_data = organizationData.users.find((user: { id: any; }) => user.id == selectedMember);
                        if(user_data != undefined && user_data?.tabs != null && user_data.tabs.length > 0) {

                            let selected_tab = user_data.tabs.find((tab: { open: boolean; }) => tab.open == true)
                            if(selected_tab != undefined && selected_tab?.name != undefined && selected_tab?.name.trim() != '') {
                                if(selected_tab?.selected_item_id != undefined) {
                                    //verifiy if id is sub
                                    let selected_datum = findDatumByDatumIdInAllTools(cna_data, parseInt(selected_tab.selected_item_id))
                                    if(selected_datum?.datum_found?.idParent != undefined) {
                                        datumOpenId = selected_datum.datum_found.idParent.toString();
                                    } else {
                                        datumOpenId = selected_tab.selected_item_id.toString();
                                    }
                                }
                            }
                        }
                    }
                }
            }
        } else {
            if(cna?.datum_id_open_data?.datum_found?.idParent != null) {
                return [cna.datum_id_open_data.datum_found.idParent.toString()]
            }
        }

        return [datumOpenId]
    }
    const getSubDatumModalOpenKey = () => {
        if(cna?.datum_id_open_data?.datum_found?.idParent != null) {
            return [cna.datum_id_open.toString()]
        } else {
            if(cna.isLoading === false && cna.isLoadingFullData === false) {
                let remember_data = tool_cna_remember?.remember
                if(remember_data != null && remember_data.length > 0) {
                    const organization_id = team_obj.data.idOrganization;
                    const team_id = team_obj.data.id;

                    let organizationData = remember_data.find((org: { organization_id: number; team_id:number; view:'team'|'member'}) => (
                        org.organization_id === organization_id && org.team_id === team_id && org.view === 'member'
                    ));

                    if(organizationData) {
                        let user_data = organizationData.users.find((user: { id: any; }) => user.id == selectedMember);
                        if(user_data != undefined && user_data?.tabs != null && user_data.tabs.length > 0) {

                            let selected_tab = user_data.tabs.find((tab: { open: boolean; }) => tab.open == true)
                            if(selected_tab != undefined && selected_tab?.name != undefined && selected_tab?.name.trim() != '') {
                                if(selected_tab?.selected_item_id != undefined) {
                                    //verifiy if id is sub
                                    let selected_datum = findDatumByDatumIdInAllTools(cna_data, parseInt(selected_tab.selected_item_id))
                                    if(selected_datum?.datum_found?.idParent != undefined) {
                                        return [selected_tab.selected_item_id.toString()]
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return ["0"]
    }
    const getSelectedTool = () => {
        if(cna?.datum_id_open_data?.selected_tool !== undefined) {
            return parseToolsNamesToTabNames(cna.datum_id_open_data.selected_tool)
        }
        return 'Deliverables'
    }
    const [selectedDatumType, setSelectedDatumType] = useState(getSelectedTool() || 'deliverables');
    const [headlineOpenId, setHeadlineOpenId] = useState(null);
    const [headlineParentOpenId, setHeadlineParentOpenId] = useState<number | null>(null);
    const [headlineCommentOpenId, setHeadlineCommentOpenId] = useState(null);
    const [datumModalOpenKey, setDatumModalOpenKey] = useState(getDatumModalOpenKey());
    const [subdatumModalOpenKey, setSubDatumModalOpenKey] = useState(getSubDatumModalOpenKey());
    const [selectedEmailMembers, setSelectedEmailMembers] = useState([]);
    const markingAsReadRef = useRef<Set<number>>(new Set());

    // Add cleanup ref to prevent state updates on unmounted component
    const isMountedRef = useRef(true);

    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    useEffect(() => {
        let datumOpenId = cna.datum_id_open.toString();

        if(cna.isLoading === false && cna.isLoadingFullData === false && datumOpenId == '0') {
            let remember_data = tool_cna_remember?.remember
            if(remember_data != null && remember_data.length > 0) {
                const organization_id = team_obj.data.idOrganization;
                const team_id = team_obj.data.id;

                let organizationData = remember_data.find((org: { organization_id: number; team_id:number; view:'team'|'member'}) => (
                    org.organization_id === organization_id && org.team_id === team_id && org.view === 'member'
                ));

                if(organizationData) {
                    let user_data = organizationData.users.find((user: { id: any; }) => user.id == selectedMember);
                    if(user_data != undefined && user_data?.tabs != null && user_data.tabs.length > 0) {

                        let selected_tab = user_data.tabs.find((tab: { open: boolean; }) => tab.open == true)
                        if(selected_tab != undefined && selected_tab?.name != undefined && selected_tab?.name.trim() != '') {

                            if(selected_tab.name == 'deliverables') {
                                setSelectedDatumType('Deliverables')
                            } else if(selected_tab.name == 'tomis') {
                                setSelectedDatumType('TOMIs')
                            } else if(selected_tab.name == 'activities') {
                                setSelectedDatumType('Activities')
                            } else if(selected_tab.name == 'messages') {
                                setSelectedDatumType('Messages')
                            }

                            if(selected_tab?.selected_item_id != undefined) {
                                setDatumModalOpenKey(selected_tab.selected_item_id.toString());
                                dispatch(setDatumIdOpen(selected_tab.selected_item_id));
                            }
                        }
                    }
                }
            }
        }
    }, [cna.isLoading, cna.isLoadingFullData, tool_cna_remember, selectedMember])

    useEffect(() => {
        if (datumOpenId && datumOpenId > 0) {
            dispatch(fetchDatumById(datumOpenId));
        }
    }, [datumOpenId]);

    // One-time "jump" to open accordion from search results
    // Uses URL parameter as trigger - consumed immediately to prevent loops
    const [jumpToId, setJumpToId] = useState<number | null>(null);
    const lastJumpRef = useRef<number | null>(null);

    // Set jumpToId when URL has datum_id (from search navigation)
    useEffect(() => {
        if (datum_id && parseInt(datum_id) > 0) {
            const datumIdNum = parseInt(datum_id);
            // Only set if it's a new ID (not already processed)
            if (lastJumpRef.current !== datumIdNum) {
                setJumpToId(datumIdNum);
            }
        }
    }, [datum_id]);

    // Handle the jump - open accordion once, then consume
    useEffect(() => {
        if (!jumpToId) return;
        // Wait for data to be loaded
        if (cna.isLoadingFullData || !cna_data || cna_data.length === 0) return;

        // Find the datum in the data
        const selected_datum = findDatumByDatumIdInAllTools(cna_data, jumpToId);
        
        if (selected_datum && selected_datum.datum_found) {
            // Determine the accordion key - handle parent/child relationships
            let accordionKey = jumpToId.toString();
            if (selected_datum.datum_found.idParent != null && selected_datum.datum_found.idParent > 0) {
                // If it's a sub-item, open the parent accordion
                accordionKey = selected_datum.datum_found.idParent.toString();
            }

            // Update selected datum type based on the tool
            if (selected_datum.selected_tool) {
                const toolName = parseToolsNamesToTabNames(selected_datum.selected_tool);
                if (toolName) {
                    setSelectedDatumType(toolName);
                }
            }

            // Open the accordion
            setDatumModalOpenKey([accordionKey]);

            // Scroll to the item after it opens
            setTimeout(() => {
                const selectors = [
                    `button[aria-controls*="${accordionKey}"]`,
                    `[data-event-key="${accordionKey}"]`,
                    `.accordion-item[data-event-key="${accordionKey}"]`,
                    `[aria-controls*="flush-collapse-${accordionKey}"]`
                ];
                
                let element: HTMLElement | null = null;
                for (const selector of selectors) {
                    element = document.querySelector(selector) as HTMLElement;
                    if (element) break;
                }
                
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 300);
        }

        // Consume immediately - clear jumpToId so it can't loop or prevent manual close
        lastJumpRef.current = jumpToId;
        setJumpToId(null);
    }, [jumpToId, cna.isLoadingFullData, cna_data]);




    if(team_obj.isLoading || cna.isLoadingFullData) {
        return <Loading />;
    }

    let selected_member_is_owner = false;
    if(authenticated_user.id == selectedMember) {
        selected_member_is_owner = true;
    }

    const createEmptyToolData = () => ({
        data: [],
        total_notifications: 0,
    });

    const createEmptyMemberData = () => ({
        deliverables: createEmptyToolData(),
        tomis: createEmptyToolData(),
        activities: createEmptyToolData(),
        messages: createEmptyToolData(),
    });

    let member = team_obj?.data?.members?.find((member: { id: number; }) => (member.id == selectedMember))
    let cna_member_data = cna_data.find((datum: { user_id: number; }) => (datum.user_id == selectedMember)) || createEmptyMemberData()

    let cna_member_archived_data: any = createEmptyMemberData();

    if(isLoadingArchivedData == false) {
        cna_member_archived_data = cna_archived_data.find((datum: { user_id: number; }) => (datum.user_id == selectedMember)) || createEmptyMemberData()
    }

    const normalizeAccordionEventKeys = (eventKeys: any, currentKeys: string[]): string[] => {
        if (Array.isArray(eventKeys)) {
            return eventKeys.map((key) => key.toString());
        }

        if (typeof eventKeys === 'string') {
            return currentKeys.includes(eventKeys)
                ? currentKeys.filter((key) => key !== eventKeys)
                : [...currentKeys, eventKeys];
        }

        return [];
    };

    const handleMainAccordionSelect = (eventKeys: any) => {
        const currentKeys = Array.isArray(datumModalOpenKey)
            ? datumModalOpenKey.map((key) => key.toString())
            : (datumModalOpenKey ? [datumModalOpenKey.toString()] : []);
        const nextKeys = normalizeAccordionEventKeys(eventKeys, currentKeys);
        const newlyOpenedKeys = nextKeys.filter((key) => !currentKeys.includes(key));

        if (newlyOpenedKeys.length > 0) {
            const selectedToolData = cna_member_data[selectedDatumType.toLowerCase()]?.data || [];
            newlyOpenedKeys.forEach((key) => {
                const datumId = parseInt(key, 10);
                if (Number.isNaN(datumId)) {
                    return;
                }

                const openedDatum = findDatumByDatumId(selectedToolData, datumId);
                if (openedDatum?.total_notifications > 0) {
                    handleMarKNotificationsAsRead(datumId, 'newChange').catch(() => {});
                }
            });
        }

        setDatumModalOpenKey(nextKeys);
    };

    const handleArchivedAccordionSelect = (eventKeys: any) => {
        const currentKeys = Array.isArray(datumModalOpenKey)
            ? datumModalOpenKey.map((key) => key.toString())
            : (datumModalOpenKey ? [datumModalOpenKey.toString()] : []);
        const nextKeys = normalizeAccordionEventKeys(eventKeys, currentKeys);
        setDatumModalOpenKey(nextKeys);
    };

    const clickNewItem = (type_name:string, parent_datum_id:number|null = null) => {
        if(type_name == 'Deliverable') {
            type_name = 'Deliverables';
        } else if(type_name == 'Headline') {
            type_name = 'TOMIs';
        } else if(type_name == 'Activity') {
            type_name = 'Activities';
        }

        setSelectedDatumType(type_name)

        let prefix_title = 'New'
        if(parent_datum_id != null && parent_datum_id > 0) {
            generateSpecificCnARoute(parent_datum_id)
            setHeadlineParentOpenId(parent_datum_id);
            prefix_title = 'New Sub'
        }

        if(type_name == 'Deliverables') {
            setHeadlineModalSettings({
                ...headlineModalSettings,
                title: `${prefix_title} Deliverable`,
                new_record: true,
                is_comment: false,
                is_draft: false,
                labels: {
                    title: 'Deliverable',
                    description: 'Story'
                }
            });
        } else if(type_name == 'ToMIs') {
            setHeadlineModalSettings({
                ...headlineModalSettings,
                title: `${prefix_title} TOMI™`,
                new_record: true,
                is_comment: false,
                is_draft: false,
                labels: {
                    title: 'TOMI™',
                    description: 'Story'
                }
            });
        
        } else if (type_name == 'Activities') {
            setHeadlineModalSettings({
                ...headlineModalSettings,
                title: `${prefix_title} Activity`,
                new_record: true,
                is_comment: false,
                is_draft: false,
                labels: {
                    title: 'Activity',
                    description: 'Story'
                }
            });
        } else if (type_name == 'Messages') {
            setHeadlineModalSettings({
                ...headlineModalSettings,
                title: `${prefix_title} Message`,
                new_record: true,
                is_comment: false,
                is_draft: false,
                labels: {
                    title: 'Message',
                    description: 'Message'
                }
            });
        }

        setHeadlineData({
            content_id: '',
            title: '',
            description: '',
            links: [],
            uploads: [],
            document_library_item_ids: [],
            document_library_items: [],
            type: '',
            start_date: '',
            start_time: '',
            end_date: '',
            end_time: '',
            is_all_day: false,
            event_location: '',
            add_to_calendar: false,
            event_attendees: [],
            custom_attendees: ''
        });
        setDisableSubmitBtn(false); // Reset submit button when opening modal
        setShowCreateItemModal(true);
        setSelectedEmailMembers([]);
    }

    const buildDocumentLibraryState = (documents:any[] = [], rawLinks:any[] = [], rawUploads:any[] = []) => {
        const documentLibraryItems = Array.isArray(documents) ? documents : [];
        const documentLibraryItemIds = documentLibraryItems
            .map((item:any) => parseInt(item?.id, 10))
            .filter((id:number) => Number.isInteger(id) && id > 0);

        const linkDocumentMap = new Map(
            documentLibraryItems
                .filter((item:any) => typeof item?.external_url === 'string' && item.external_url.trim() !== '')
                .map((item:any) => [item.external_url, item.id])
        );

        const uploadDocumentMap = new Map(
            documentLibraryItems
                .filter((item:any) => typeof item?.storage_path === 'string' && item.storage_path.trim() !== '')
                .map((item:any) => [item.storage_path, item.id])
        );

        const links = (Array.isArray(rawLinks) ? rawLinks : []).map((link:any) => ({
            id: link.id,
            link: link.links,
            document_library_item_id: linkDocumentMap.get(link.links) || null,
        }));

        const uploads = (Array.isArray(rawUploads) ? rawUploads : []).map((upload:any) => ({
            id: upload.id,
            file_name: upload.fileName,
            display_name: upload.displayName,
            document_library_item_id: uploadDocumentMap.get(upload.fileName) || null,
        }));

        return {
            links,
            uploads,
            document_library_item_ids: documentLibraryItemIds,
            document_library_items: documentLibraryItems,
        };
    }

    const handleCloseCreateCoachNoteModal = () => {
        setHeadlineOpenId(null)
        setHeadlineCommentOpenId(null)
        setDisableSubmitBtn(false); // Reset submit button when closing modal
        setShowCreateItemModal(false)
    };

    const headlineSubmit = async (doNotNotify = false, saveAsDraft = false) => {
        const organization_id = team_obj.data.idOrganization;
        const team_id = team_obj.data.id;
        let url = zynity_api.organization_team.replace('{organization_id}', organization_id).replace('{team_id}', team_id);
        url += `/tools/CnA`;

        if(headlineModalSettings.is_comment === false) {
            let type = 'Headline';
            if(selectedDatumType == 'Deliverables') {
                type = 'Deliverable'
            }  else if(selectedDatumType == 'ToMIs') {
                type = 'Headline'
            } else if (selectedDatumType == 'Activities') {
                type = 'Activity'
            } else if (selectedDatumType == 'Messages') {
                type = 'Message'
            }

            if(headlineParentOpenId != null && headlineParentOpenId > 0) {
                type = 'Subheadline'
            }

            // 👇 Merge date and time into single datetime strings
            let event_start = '';
            let event_end = '';

            if (eventData.start_date) {
                event_start = eventData.start_date;
                if (eventData.start_time) {
                    event_start += ` ${eventData.start_time}`;
                } else {
                    event_start += ` 00:00:00`;
                }
            }

            if (eventData.end_date) {
                event_end = eventData.end_date;
                if (eventData.end_time) {
                    event_end += ` ${eventData.end_time}`;
                } else {
                    event_end += ` 00:00:00`;
                }
            }

            let formData:any = {
                ...headlineData,
                type: type,
                ...eventData,
                event_start,
                event_end,
            };

            formData = {...formData, email_members: selectedEmailMembers}
            if (saveAsDraft) {
                formData = {
                    ...formData,
                    save_as_draft: true,
                    content_status: 'Draft',
                }
            } else if (headlineModalSettings.new_record === false && headlineModalSettings.is_draft === true) {
                // Posting an existing draft publishes it.
                formData = {
                    ...formData,
                    save_as_draft: false,
                    content_status: 'Active',
                }
            }

            if (selectedDatumType == 'Messages') {
                formData = {...formData, assigned_to: selectedMember}
            }

            // Add the doNotNotify parameter to the form data
            formData = {...formData, do_not_notify: doNotNotify}

            if(formData.title.trim() == '') {
                Swal.fire({
                    icon: 'warning',
                    text: 'Please add a note name'
                })
                return false;
            }

            setDisableSubmitBtn(true)
            if(headlineModalSettings.new_record === true) {
                if(type == 'Subheadline') {
                    url += '/' + headlineParentOpenId;
                }
                await axios.post(`${url}`, formData)
                    .then(async (response) => {
                        try {
                            console.log("🚀 New item created, response:", response.data);

                            // Check if component is still mounted before proceeding
                            if (!isMountedRef.current) {
                                console.log("⚠️ Component unmounted, skipping remember state update");
                                return;
                            }

                            // Find the newly created item ID from the response
                            let newItemId = null;
                            if (response.data && response.data.data && Array.isArray(response.data.data)) {
                                // Find the most recently created item (last created based on dateCreated)
                                const sortedItems = response.data.data.sort((a: any, b: any) =>
                                    new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime()
                                );
                                const newlyCreatedItem = sortedItems[0]; // Most recent item
                                newItemId = newlyCreatedItem?.id;

                                console.log("🆕 Found new item ID:", newItemId, "in tab:", selectedDatumType.toLowerCase());
                            }

                            // Set remember state BEFORE refreshing data to avoid race conditions
                            if (newItemId && isMountedRef.current) {
                                let rememberData:any = {
                                    organization_id: organization_id,
                                    team_id: team_id,
                                    view: 'member',
                                    user_id: selectedMember,
                                    tab_name: selectedDatumType.toLowerCase(),
                                    selected_item_id: newItemId,
                                }
                                await dispatch(collabSetRemember(rememberData));
                                console.log("✅ Remember state set BEFORE data refresh for new item:", newItemId);

                                // Set the datum open state immediately
                                setDatumModalOpenKey([newItemId.toString()]);
                                dispatch(setDatumIdOpen(newItemId));
                            }

                            // Then refresh the data
                            await dispatch( getCnAData({organization_id, team_id}) );

                            console.log("📊 Data refreshed after creating new item");

                        } catch (rememberError) {
                            console.error("❌ Error in new item creation flow:", rememberError);
                            // Don't fail the entire operation if remember fails
                        }

                        // Check if component is still mounted before updating state
                        if (isMountedRef.current) {
                            setShowCreateItemModal(false)
                            setDisableSubmitBtn(false)
                        }
                    }).catch((error) => {
                        setDisableSubmitBtn(false)
                        console.error('Create error:', error);
                        console.error('Create error response:', error?.response);
                        console.error('Create error data:', error?.response?.data);
                        const errorMessage = error?.response?.data?.message || error?.response?.data?.error || error?.message || `We have problems creating your ${type}, please try again!`;
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: errorMessage,
                        })
                        throw error;
                    })
            } else {
                url = `${url}/${headlineOpenId}`
                await axios.put(`${url}`, formData)
                    .then(async (response) => {
                        // First refresh the data
                        await dispatch( getCnAData({organization_id, team_id}) );

                        // Then update remember state for edit operations
                        let rememberData:any = {
                            organization_id: organization_id,
                            team_id: team_id,
                            view: 'member',
                            user_id: selectedMember,
                            tab_name: selectedDatumType.toLowerCase(),
                            selected_item_id: headlineOpenId, // Use the edited item's ID
                        }
                        dispatch(collabSetRemember(rememberData))

                        setShowCreateItemModal(false)
                        setDisableSubmitBtn(false)
                    }).catch((error) => {
                        setDisableSubmitBtn(false)
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: `We have problems updating your ${type}, please try again!`,
                        })
                        throw error;
                    })
            }
        } else {
            let formData:any = {...headlineData};

            formData = {...formData, email_members: selectedEmailMembers}

            // Add the doNotNotify parameter to the form data
            formData = {...formData, do_not_notify: doNotNotify}

            if(formData.description.trim() == '') {
                Swal.fire({
                    icon: 'warning',
                    text: 'Please add a description'
                })
            }
            url = `${url}/${headlineOpenId}/comments`
            if(headlineCommentOpenId !== null && headlineCommentOpenId > 0) {
                url = `${url}/${headlineCommentOpenId}`
            }

            setDisableSubmitBtn(true)
            if(headlineModalSettings.new_record) {
                await axios.post(`${url}`, formData)
                    .then((response) => {
                        dispatch( getCnAData({organization_id, team_id}) );
                        setShowCreateItemModal(false)
                        setDisableSubmitBtn(false)
                    }).catch((error) => {
                        setDisableSubmitBtn(false)
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: `We have problems creating your comment, please try again!`,
                        })
                        throw error;
                    })
            } else {
                await axios.put(`${url}`, formData)
                    .then((response) => {
                        dispatch( getCnAData({organization_id, team_id}) );
                        setShowCreateItemModal(false)
                        setDisableSubmitBtn(false)
                    }).catch((error) => {
                        setDisableSubmitBtn(false)
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: `We have problems updating your comment, please try again!`,
                        })
                        throw error;
                    })
            }
        }
    }

    const handleCloseReminderModal = () => {
        setHeadlineOpenId(null)
        setShowReminderModal(false)
    };

    const clickEditItem = (datum_id:any) => {
        setHeadlineOpenId(datum_id)
        let datum = findDatumByDatumId(cna_member_data[selectedDatumType.toLowerCase()].data, datum_id)
        const datumIsDraft = isDatumDraft(datum);
        const documentLibraryState = buildDocumentLibraryState(datum?.documents, datum?.links, datum?.uploads);
        console.log("selectedDatumType", selectedDatumType);
        if(selectedDatumType == 'Deliverables') {
            setHeadlineModalSettings({
                ...headlineModalSettings,
                title: 'Edit Deliverable',
                new_record: false,
                is_comment: false,
                is_draft: datumIsDraft,
                enable_document_library: true,
                labels: {
                    title: 'Deliverable',
                    description: 'Story'
                }
            });
        } else if(selectedDatumType == 'TOMIs') {
            setHeadlineModalSettings({
                ...headlineModalSettings,
                title: 'Edit TOMI™',
                new_record: false,
                is_comment: false,
                is_draft: datumIsDraft,
                enable_document_library: true,
                labels: {
                    title: 'TOMI™',
                    description: 'Story'
                }
            });
        } else if (selectedDatumType == 'Activities') {
            setHeadlineModalSettings({
                ...headlineModalSettings,
                title: 'Edit Activity',
                new_record: false,
                is_comment: false,
                is_draft: datumIsDraft,
                enable_document_library: true,
                labels: {
                    title: 'Activity',
                    description: 'Story'
                }
            });
        } else if (selectedDatumType == 'Messages') {
            setHeadlineModalSettings({
                ...headlineModalSettings,
                title: 'Edit Message',
                new_record: false,
                is_comment: false,
                is_draft: datumIsDraft,
                enable_document_library: true,
                labels: {
                    title: 'Message',
                    description: 'Story'
                }
            });
        }
        const { event_attendees, custom_attendees } = splitAttendees(datum?.event_attendees || "", team_obj);

        setHeadlineData({
            content_id: datum.datum_content_id,
            title: datum.title,
            description: datum.description,
            links: documentLibraryState.links,
            uploads: documentLibraryState.uploads,
            document_library_item_ids: documentLibraryState.document_library_item_ids,
            document_library_items: documentLibraryState.document_library_items,
            type: '',
            start_date: datum.event_start?.substring(0, 10) || '',
            start_time: datum.event_start?.substring(11, 16) || '',
            end_date: datum.event_end?.substring(0, 10) || '',
            end_time: datum.event_end?.substring(11, 16) || '',
            is_all_day: datum.is_all_day === 1 || datum.is_all_day === true,
            event_location: datum.event_location || '',
            add_to_calendar: false,
            event_attendees,
            custom_attendees
        });

        setEventData({
            start_date: datum.event_start?.substring(0, 10) || '',
            start_time: datum.event_start?.substring(11, 16) || '',
            end_date: datum.event_end?.substring(0, 10) || '',
            end_time: datum.event_end?.substring(11, 16) || '',
            is_all_day: datum.is_all_day === 1 || datum.is_all_day === true,
            event_location: datum.event_location || '',
            add_to_calendar: false,
            event_attendees,
            custom_attendees
        });

        generateSpecificCnARoute(datum_id)
        setDisableSubmitBtn(false); // Reset submit button when opening modal
        setShowCreateItemModal(true);
        setSelectedEmailMembers([]);
    }

    function splitAttendees(attendeesStr = "", team_obj) {
        const emails = attendeesStr
            .split(",")
            .map(e => e.trim())
            .filter(Boolean);

        const userIds = [];
        const externalEmails = [];

        const seenIds = new Set();
        const seenEmails = new Set();

        for (const email of emails) {
            const id = getAuthorIdByEmail(email, team_obj); // number | null
            if (typeof id === "number" && !Number.isNaN(id)) {
                if (!seenIds.has(id)) {
                    seenIds.add(id);
                    userIds.push(id);
                }
            } else {
                const lower = email.toLowerCase();
                if (!seenEmails.has(lower)) {
                    seenEmails.add(lower);
                    externalEmails.push(email); // keep original casing if you prefer
                }
            }
        }

        return {
            event_attendees: userIds,
            custom_attendees: externalEmails.join(", "),
        };
    }

    const generateSpecificCnARoute = async (datum_id: number) => {
        const organization_id = team_obj.data.idOrganization;
        const team_id = team_obj.data.id;
        let route = `/organizations/${organization_id}/teams/${team_id}/CnA/${datum_id}`
        dispatch(setRoute(route))
        dispatch( setDatumIdOpen(datum_id) );
        let selected_datum = findDatumByDatumIdInAllTools(cna_data, parseInt(cna.datum_id_open))
        if(selected_datum !== undefined) {
            await dispatch( setDatumIdOpenData(0) );
            await dispatch( setDatumIdOpenData(selected_datum) );
        }
    }

    const clickAddComment = (datum_id:number, parent_comment:any = null) => {
        generateSpecificCnARoute(datum_id)
        let datum = findDatumByDatumId(cna_member_data[selectedDatumType.toLowerCase()].data, datum_id)
        setHeadlineOpenId(datum_id)
        setHeadlineCommentOpenId(parent_comment)

        let title = 'New Comment'
        if(parent_comment != null) {
            title = 'Add Reply'
        }

        setHeadlineModalSettings({
            ...headlineModalSettings,
            title: title,
            new_record: true,
            is_comment: true,
            enable_document_library: true,
            labels: {
                title: 'Title',
                description: 'Comment'
            }
        });

        setHeadlineData({
            content_id: datum.datum_content_id,
            title: '',
            description: '',
            links: [],
            uploads: [],
            document_library_item_ids: [],
            document_library_items: [],
            type: '',
            start_date: '',
            start_time: '',
            end_date: '',
            end_time: '',
            is_all_day: false,
            event_location: '',
            add_to_calendar: false,
            event_attendees: [],
            custom_attendees: ''
        });
        setDisableSubmitBtn(false); // Reset submit button when opening modal
        setShowCreateItemModal(true);
        setSelectedEmailMembers([]);
    }

    const clickEditComment = (datum_id:any, comment_id:number, reply_id:number = null, reply2_id:number = null) => {
        generateSpecificCnARoute(datum_id)
        setHeadlineCommentOpenId(comment_id)
        setHeadlineOpenId(datum_id)
        let datum = findDatumByDatumId(cna_member_data[selectedDatumType.toLowerCase()].data, datum_id)
        let comment = datum.comments.find((comment: { id: any; }) => comment.id === comment_id);

        if(reply_id !== null) {
            comment = comment.comments.find((comment: { id: any; }) => comment.id === reply_id);
            setHeadlineCommentOpenId(reply_id)
        }

        if(reply2_id !== null) {
            comment = comment.comments.find((comment: { id: any; }) => comment.id === reply2_id);
            setHeadlineCommentOpenId(reply2_id)
        }

        setHeadlineModalSettings({
            ...headlineModalSettings,
            title: 'Edit Comment',
            new_record: false,
            is_comment: true,
            enable_document_library: true
        });
        const documentLibraryState = buildDocumentLibraryState(comment?.documents, comment?.links, comment?.uploads);

        const { event_attendees, custom_attendees } = splitAttendees(datum?.event_attendees || "", team_obj);

        setHeadlineData({
            content_id: datum.datum_content_id,
            title: '',
            description: comment.comment,
            links: documentLibraryState.links,
            uploads: documentLibraryState.uploads,
            document_library_item_ids: documentLibraryState.document_library_item_ids,
            document_library_items: documentLibraryState.document_library_items,
            type: '',
            start_date: datum.event_start?.substring(0, 10) || '',
            start_time: datum.event_start?.substring(11, 16) || '',
            end_date: datum.event_end?.substring(0, 10) || '',
            end_time: datum.event_end?.substring(11, 16) || '',
            is_all_day: datum.is_all_day === 1 || datum.is_all_day === true,
            event_location: datum.event_location || '',
            add_to_calendar: false,
            event_attendees,
            custom_attendees
        });

        setEventData({
            start_date: datum.event_start?.substring(0, 10) || '',
            start_time: datum.event_start?.substring(11, 16) || '',
            end_date: datum.event_end?.substring(0, 10) || '',
            end_time: datum.event_end?.substring(11, 16) || '',
            is_all_day: datum.is_all_day === 1 || datum.is_all_day === true,
            event_location: datum.event_location || '',
            add_to_calendar: false,
            event_attendees,
            custom_attendees
        });

        setDisableSubmitBtn(false); // Reset submit button when opening modal
        setShowCreateItemModal(true);
        setSelectedEmailMembers([]);
    }

    const clickRemoveComment = (datum_id:any, comment_id:number) => {
        const organization_id = team_obj.data.idOrganization;
        const team_id = team_obj.data.id;

        let url = zynity_api.organization_team.replace('{organization_id}', organization_id).replace('{team_id}', team_id);
        url += `/tools/CnA/${datum_id}/comments/${comment_id}`;

        Swal.fire({
            title: `Are you sure you want to delete this comment?`,
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete it!',
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire('Comment Deleted!', '', 'success')
                axios.delete(`${url}`)
                    .then((response) => {
                        dispatch( getCnAData({organization_id, team_id}) );
                    }).catch((error) => {
                    throw error;
                })
            }
        })
    }

    const clickDeleteItem = async (datum_id:number) => {
        const organization_id = team_obj.data.idOrganization;
        const team_id = team_obj.data.id;
        // Check both active and archived data sources
        let datum = findDatumByDatumId(cna_member_data[selectedDatumType.toLowerCase()].data, datum_id)
        if (!datum && cna_member_archived_data && cna_member_archived_data[selectedDatumType.toLowerCase()]) {
            datum = findDatumByDatumId(cna_member_archived_data[selectedDatumType.toLowerCase()].data, datum_id)
        }

        if (!datum) {
            Swal.fire('Error', 'Item not found', 'error')
            return
        }

        // Validate required fields
        if (!datum.datum_content_id) {
            console.error('Delete error: datum_content_id missing', datum);
            Swal.fire('Error', 'Missing required data (content_id)', 'error')
            return
        }

        if (!datum.type1) {
            console.error('Delete error: type1 missing', datum);
            Swal.fire('Error', 'Missing required data (type)', 'error')
            return
        }

        // Check if item is from archived data
        const isArchived = !findDatumByDatumId(cna_member_data[selectedDatumType.toLowerCase()].data, datum_id) && 
                          (cna_member_archived_data && cna_member_archived_data[selectedDatumType.toLowerCase()] && 
                           findDatumByDatumId(cna_member_archived_data[selectedDatumType.toLowerCase()].data, datum_id));
        
        let url = zynity_api.organization_team.replace('{organization_id}', organization_id).replace('{team_id}', team_id);
        url += `/tools/CnA/${datum_id}?content_id=${datum.datum_content_id}&type=${datum.type1}`;
        
        console.log('Delete URL:', url);
        console.log('Is Archived:', isArchived);
        console.log('Full Datum object:', datum);
        console.log('Datum data:', { 
            id: datum_id, 
            content_id: datum.datum_content_id, 
            type: datum.type1, 
            status: datum.status,
            datum_content_id: datum.datum_content_id,
            idDatum: datum.idDatum,
            idParent: datum.idParent
        });

        Swal.fire({
            title: `Are you sure you want to delete this item?`,
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete it!',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    // Backend now handles both active and archived items
                    await axios.delete(`${url}`)
                    await dispatch( getCnAData({organization_id, team_id}) );
                    Swal.fire('Item Deleted!', '', 'success')
                } catch (error: any) {
                    console.error('Delete error:', error);
                    console.error('Delete error response:', error?.response);
                    console.error('Delete error data:', error?.response?.data);
                    const errorMessage = error?.response?.data?.message || error?.response?.data?.error || error?.message || 'Failed to delete item';
                    Swal.fire('Error', errorMessage, 'error')
                }
            }
        })
    }

    const clickPrivateItem = async (datum_id:number) => {
        let datum = findDatumByDatumId(cna_member_data[selectedDatumType.toLowerCase()].data, datum_id)
        const organization_id = team_obj.data.idOrganization;
        const team_id = team_obj.data.id;
        let url = zynity_api.organization_team.replace('{organization_id}', organization_id).replace('{team_id}', team_id);
        url += `/tools/CnA/${datum_id}/private?content_id=${datum.datum_content_id}`;

        await axios.post(`${url}`)
            .then((response) => {
                dispatch( getCnAData({organization_id, team_id}) );
                generateSpecificCnARoute(datum_id)
            }).catch((error) => {
                throw error;
            })
    }

    const clickMoveItem = (datum_id:number) => {
        setMoveItemSelectedItemId(datum_id)
        setMoveItemNewType('')
        setShowMoveItemModal(true)
    }

    const moveItemHandled = async () => {
        let datum_id = moveItemSelectedItemId;
        let type = moveItemNewType;
        let datum = findDatumByDatumId(cna_member_data[selectedDatumType.toLowerCase()].data, datum_id)
        const organization_id = team_obj.data.idOrganization;
        const team_id = team_obj.data.id;
        let url = zynity_api.organization_team.replace('{organization_id}', organization_id).replace('{team_id}', team_id);
        url += `/tools/CnA/${datum_id}/move?content_id=${datum.datum_content_id}&new_type=${type}`;

        await axios.post(`${url}`)
            .then((response) => {
                dispatch( getCnAData({organization_id, team_id}) );
                generateSpecificCnARoute(datum_id)
            }).catch((error) => {
                throw error;
            })
    }

    const clickArchiveItem = async (datum_id:number) => {
        let datum = findDatumByDatumId(cna_member_data[selectedDatumType.toLowerCase()].data, datum_id)
        await handleActiveArchiveItem(datum_id, datum.datum_content_id)
    }

    const clickActiveItem = async (datum_id:number) => {
        let datum = findDatumByDatumId(cna_member_archived_data[selectedDatumType.toLowerCase()].data, datum_id)
        await handleActiveArchiveItem(datum_id, datum.datum_content_id)
    }

    const handleActiveArchiveItem = async (datum_id:any, content_id:any) => {
        const organization_id = team_obj.data.idOrganization;
        const team_id = team_obj.data.id;
        let url = zynity_api.organization_team.replace('{organization_id}', organization_id).replace('{team_id}', team_id);
        url += `/tools/CnA/${datum_id}/archive?content_id=${content_id}`;

        await axios.post(`${url}`)
            .then((response) => {
                dispatch( getCnAData({organization_id, team_id}) );
                generateSpecificCnARoute(datum_id)
            }).catch((error) => {
                throw error;
            })
    }

    const handleChangeListOrder = async (item_id: number, newPriority: number, parentDatumId:number = null) => {
        generateSpecificCnARoute(item_id)
        const organization_id = team_obj.data.idOrganization;
        const team_id = team_obj.data.id;

        let datum = findDatumByDatumId(cna_member_data[selectedDatumType.toLowerCase()].data, item_id)

        let selected_datum_items = cna_member_data[selectedDatumType.toLowerCase()].data;
        if(datum.idParent !== null) {
            let parent_datum = findDatumByDatumId(cna_member_data[selectedDatumType.toLowerCase()].data, datum.idParent)
            selected_datum_items = parent_datum.sub_data;
        }

        let datum_content = changePriority(selected_datum_items, item_id, newPriority).map((datum:any) => {
            return datum.datum_content_id
        });

        let url = zynity_api.organization_team.replace('{organization_id}', organization_id).replace('{team_id}', team_id);
        url += `/tools/CnA/change_list_order`;
        await axios.put(url, {datum_content_id: datum_content})
            .then((response) => {
                dispatch( getCnAData({organization_id, team_id}) );
            }).catch((error) => {
                throw error;
            })
    }

    const markNotificationsAsReadLocally = (toolData: any, itemId: number) => {
        const updateDatumList = (list: any[]): { list: any[]; changed: boolean; removedCount: number } => {
            let changed = false;
            let removedCount = 0;

            const updatedList = list.map((datum: any) => {
                let datumChanged = false;
                let nextDatum = datum;

                if (datum.id === itemId) {
                    const currentNotifications = Number(datum.total_notifications) || 0;
                    if (currentNotifications > 0) {
                        removedCount += currentNotifications;
                        nextDatum = {
                            ...nextDatum,
                            total_notifications: 0
                        };
                        datumChanged = true;
                    }
                }

                if (Array.isArray(datum?.sub_data) && datum.sub_data.length > 0) {
                    const subUpdate = updateDatumList(datum.sub_data);
                    if (subUpdate.changed) {
                        nextDatum = {
                            ...nextDatum,
                            sub_data: subUpdate.list
                        };
                        datumChanged = true;
                    }
                    removedCount += subUpdate.removedCount;
                }

                if (Array.isArray(datum?.sub_data_archived) && datum.sub_data_archived.length > 0) {
                    const subArchivedUpdate = updateDatumList(datum.sub_data_archived);
                    if (subArchivedUpdate.changed) {
                        nextDatum = {
                            ...nextDatum,
                            sub_data_archived: subArchivedUpdate.list
                        };
                        datumChanged = true;
                    }
                    removedCount += subArchivedUpdate.removedCount;
                }

                if (datumChanged) {
                    changed = true;
                }

                return nextDatum;
            });

            return {
                list: updatedList,
                changed,
                removedCount
            };
        };

        if (!toolData || !Array.isArray(toolData.data)) {
            return null;
        }

        const updatedToolData = updateDatumList(toolData.data);
        if (!updatedToolData.changed) {
            return null;
        }

        return {
            ...toolData,
            data: updatedToolData.list,
            total_notifications: Math.max(0, (Number(toolData.total_notifications) || 0) - updatedToolData.removedCount)
        };
    };

    const handleMarKNotificationsAsRead = async (item_id: number, type: 'newChange') => {
        if (markingAsReadRef.current.has(item_id)) {
            return;
        }
        markingAsReadRef.current.add(item_id);

        generateSpecificCnARoute(item_id)
        const organization_id = team_obj.data.idOrganization;
        const team_id = team_obj.data.id;

        let url = zynity_api.organization_team.replace('{organization_id}', organization_id).replace('{team_id}', team_id);
        url += `/tools/CnA/${item_id}/mark_notifications_as_read`;
        try {
            await axios.post(url, {type: type});

            const selectedToolKey = selectedDatumType.toLowerCase();
            const currentToolData = cna_member_data[selectedToolKey];
            const nextToolData = markNotificationsAsReadLocally(currentToolData, item_id);

            if (nextToolData) {
                dispatch(updateCnAData(nextToolData, selectedMember, selectedDatumType));
            }
        } catch (error) {
            throw error;
        } finally {
            markingAsReadRef.current.delete(item_id);
        }
    }

    const handleOpenReminder = (item_id:number) => {
        let datum = findDatumByDatumId(cna_member_data[selectedDatumType.toLowerCase()].data, item_id)
        if(datum.datumNotificationReminderId != null && datum.datumNotificationReminderId > 0 &&
            datum.datumNotificationReminderComments.trim() != '')
        {
            setIsNewReminder(false)
            setReminder(datum.datumNotificationReminderComments)
        } else {
            setIsNewReminder(true)
            setReminder('')
        }
        setShowReminderModal(true)
        setHeadlineOpenId(item_id)
    }

    const handleSubmitReminder = async (type: any) => {
        const organization_id = team_obj.data.idOrganization;
        const team_id = team_obj.data.id;
        
        let datum = findDatumByDatumId(cna_member_data[selectedDatumType.toLowerCase()].data, headlineOpenId)
        let url = zynity_api.organization_team.replace('{organization_id}', organization_id).replace('{team_id}', team_id);
        url += `/tools/CnA/${headlineOpenId}/reminders`;

        if(type == 'delete' || !isNewReminder) {
            url = `${url}/${datum.datumNotificationReminderId}`
            let data = {
                content_id: datum.datum_content_id,
                comments: reminder,
                status: "unread"
            }

            if(type == 'delete') {
                data.status = "read"
            } else {
                if(reminder.trim() == '') {
                    Swal.fire({
                        icon: 'warning',
                        text: 'Please add your reminder'
                    })
                }
            }

            await axios.put(`${url}`, data)
                .then((response) => {
                    dispatch( getCnAData({organization_id, team_id}) );
                    setReminder('')
                    setShowReminderModal(false)
                }).catch((error) => {
                    throw error;
                })
            //Update/Delete
        } else {
            if(reminder.trim() == '') {
                Swal.fire({
                    icon: 'warning',
                    text: 'Please add your reminder'
                })
            }

            //Insert
            let data = {
                content_id: datum.datum_content_id,
                comments: reminder
            }
            await axios.post(`${url}`, data)
                .then((response) => {
                    dispatch( getCnAData({organization_id, team_id}) );
                    setReminder('')
                    setShowReminderModal(false)
                }).catch((error) => {
                    throw error;
                })
        }
    }

    const clickOpenTabHandled = (tab: string) => {
        const organization_id = team_obj.data.idOrganization;
        const team_id = team_obj.data.id;

        setSelectedDatumType(tab)

        let rememberData:any = {
            organization_id: organization_id,
            team_id: team_id,
            view: 'member',
            user_id: selectedMember,
            tab_name: tab.toLowerCase(),
            selected_item_id: null,
        }

        dispatch(collabSetRemember(rememberData))
    }

    const handleSelectItem = (datum:any) => {
        const organization_id = team_obj.data.idOrganization;
        const team_id = team_obj.data.id;

        let rememberData:any = {
            organization_id: organization_id,
            team_id: team_id,
            view: 'member',
            user_id: selectedMember,
            tab_name: selectedDatumType.toLowerCase(),
            selected_item_id: datum.id,
        }

        dispatch(collabSetRemember(rememberData))
    }


    return (
        <div className="container cna-member-panel-container">
            <div className="col-12 offset-0 col-xl-6 offset-xl-3">
                <Nav variant="tabs" style={{fontSize: '13px'}}>
                    {
                        datum_types.map(type => (
                            <Nav.Item
                                className={'border mx-0 mb-0'}
                                onClick={() => {clickOpenTabHandled(type.name)}}
                                style={{marginRight: '5px'}}>

                                <Nav.Link className={type.name == selectedDatumType ? 'active' : ''}>
                                    {type.name == 'ToMIs' ? 'TOMIs™' : type.name}

                                    {
                                        cna_member_data[type.name.toLowerCase()].total_notifications > 0 &&
                                        <sup style={{color: "red", fontWeight: 'bold', fontSize: '12px'}}>{cna_member_data[type.name.toLowerCase()].total_notifications}</sup>
                                    }
                                    {
                                        (
                                            (!selected_member_is_owner && type.name == 'Messages') //Page from other members but tab is message
                                            ||
                                            (selected_member_is_owner && type.name != 'Messages')) //Page from logged member for all tabs, except: Message
                                        &&
                                        <i title='Add New Item' className='mx-1 color-teal clickable badge bg-teal p-1'
                                           style={{height: 'fit-content'}}
                                           onClick={() => clickNewItem(type.name)}><FontAwesomeIcon icon={faPlus}/></i>
                                    }
                                </Nav.Link>
                            </Nav.Item>
                        ))
                    }

                    <HeadlineModal
                        showCreateModal={showCreateItemModal}
                        handleCloseModal={handleCloseCreateCoachNoteModal}
                        data={headlineData}
                        setData={setHeadlineData}
                        submitHandled={headlineSubmit}
                        settings={headlineModalSettings}
                        eventData={eventData}
                        setEventData={setEventData}
                        showEmailMembers={true}
                        emailMemberList={team_obj.data.members}
                        selectedEmailMembers={selectedEmailMembers}
                        setSelectedEmailMembers={setSelectedEmailMembers}
                        disableSubmitBtn={disableSubmitBtn}
                        showDoNotNotify={true}
                    />
                    <ReminderModal
                        showCreateModal={showReminderModal}
                        handleCloseModal={handleCloseReminderModal}
                        isNewReminder={isNewReminder}
                        reminder={reminder}
                        setReminder={setReminder}
                        submitHandled={handleSubmitReminder}
                        disableSubmitBtn={disableSubmitBtn}
                    />

                    <Modal show={showMoveItemModal} onHide={() => setShowMoveItemModal(false)} dialogAs={DraggableModalDialog} style={{cursor: 'grab'}}>
                        <Form>
                            <Modal.Header closeButton className='bg-teal draggableHandler'>
                                <Modal.Title>Move Item to:</Modal.Title>
                            </Modal.Header>
                            <Modal.Body className='row d-flex align-items-center'>
                                <div className="col-12">
                                    <select className='form-select' value={moveItemNewType} onChange={(event) => setMoveItemNewType(event.target.value)}>
                                        <option value="">Select an option</option>
                                        <option value="Deliverable">Deliverables</option>
                                        <option value="Headline">TOMIs™</option>
                                        <option value="Activity">Activities</option>
                                    </select>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setShowMoveItemModal(false)}>
                                    Cancel
                                </Button>
                                <Button className='btn-teal' onClick={() => {moveItemHandled()}} disabled={disableSubmitBtn}>
                                    Move
                                </Button>
                            </Modal.Footer>
                        </Form>
                    </Modal>
                </Nav>
            </div>

            <div className="col-12 offset-0 col-xl-6 offset-xl-3 mt-2">
                {
                    <Accordion activeKey={datumModalOpenKey} alwaysOpen onSelect={handleMainAccordionSelect}>
                        {
                            cna_member_data[selectedDatumType.toLowerCase()].data.map((datum:any) => {

                                if(selected_member_is_owner === false && datum.isPrivate == 'Private' ) {
                                    return <></>
                                }

                                return <DatumAccordionItem eventKey={datum.id.toString()}
                                    key={datum.id}
                                    datum={datum}
                                    total_coach_notes={cna_member_data[selectedDatumType.toLowerCase()].data.length}
                                    handleEditItem={clickEditItem}
                                    handleAddComment={clickAddComment}
                                    handleEditComment={clickEditComment}
                                    clickRemoveComment={clickRemoveComment}
                                    handleDeleteItem={clickDeleteItem}
                                    handleArchiveItem={clickArchiveItem}
                                    handleMarkPrivateItem={clickPrivateItem}
                                    clickMoveItem={clickMoveItem}
                                    handleChangeListOrder={handleChangeListOrder}
                                    handleOpenReminder={handleOpenReminder}
                                    handleMarKNotificationsAsRead={handleMarKNotificationsAsRead}
                                    isSubItem={false}
                                    clickNewItem={clickNewItem}
                                    readOnly={!selected_member_is_owner}
                                    selectedMember={selectedMember}
                                    subdatumModalOpenKey={subdatumModalOpenKey}
                                    handleSelectItem={handleSelectItem}
                                />
                            })
                        }
                    </Accordion>
                }
            </div>

            <div className="col-12 offset-0 col-xl-6 offset-xl-3 mt-2">
                <h5 className='text-muted'>Archived {selectedDatumType}</h5>
                {
                    isLoadingArchivedData ?
                        <span className='text-muted'>Loading...</span>
                        :
                        (
                            (cna_member_archived_data != undefined && cna_member_archived_data.hasOwnProperty(selectedDatumType.toLowerCase()) && cna_member_archived_data[selectedDatumType.toLowerCase()].data.length > 0)
                                ?
                                <Accordion activeKey={datumModalOpenKey} alwaysOpen onSelect={handleArchivedAccordionSelect}>
                                    {
                                        cna_member_archived_data[selectedDatumType.toLowerCase()].data.map((datum:any) => (
                                            <DatumAccordionItem eventKey={datum.id.toString()}
                                                key={datum.id}
                                                datum={datum}
                                                total_coach_notes={cna_member_archived_data[selectedDatumType.toLowerCase()].data.length}
                                                handleDeleteItem={clickDeleteItem}
                                                handleActiveItem={clickActiveItem}
                                                isSubItem={false}
                                                readOnly={!selected_member_is_owner}
                                                selectedMember={selectedMember}
                                                subdatumModalOpenKey={subdatumModalOpenKey}
                                            />
                                        ))
                                    }
                                </Accordion>
                                :
                                <span className='text-muted'>No Archived {selectedDatumType}</span>
                        )
                }
            </div>
        </div>
    )
}
